import { render, staticRenderFns } from "./GatedEventPage.vue?vue&type=template&id=59278a6a&scoped=true&"
import script from "./GatedEventPage.vue?vue&type=script&lang=js&"
export * from "./GatedEventPage.vue?vue&type=script&lang=js&"
import style0 from "./GatedEventPage.vue?vue&type=style&index=0&id=59278a6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59278a6a",
  null
  
)

export default component.exports